import { jsx } from 'react/jsx-runtime';
import { s as styleInject } from './style-inject.es-Bff-fD1R.js';

var css_248z = ".SGCM_UIKIT_NEXT_LinkTitle_textListTitle_1n6n3_1 {\n  min-height: 2.1rem;\n  font-size: 1.6rem;\n  font-weight: 700;\n  line-height: 1.3125;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFrQjtFQUNsQixpQkFBaUI7RUFDakIsZ0JBQWdCO0VBQ2hCLG1CQUFtQjtBQUNyQiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGV4dExpc3RUaXRsZSB7XG4gIG1pbi1oZWlnaHQ6IDIuMXJlbTtcbiAgZm9udC1zaXplOiAxLjZyZW07XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGxpbmUtaGVpZ2h0OiAxLjMxMjU7XG59Il19 */";
var styles = {"textListTitle":"SGCM_UIKIT_NEXT_LinkTitle_textListTitle_1n6n3_1"};
styleInject(css_248z);

const LinkTitle = ({ children }) => (jsx("div", { className: styles.textListTitle, children: children }));

export { LinkTitle as L };
//# sourceMappingURL=component-XhXtzyW7.js.map
